import axios from 'axios'
import * as types from "@/store/types"
import router from "@/router/index";
import store from '@/store/store'
import _ from "lodash";
// axios.defaults.timeout = 5000;

if (process.env.NODE_ENV === "production") {
  // axios.defaults.baseURL = 'http://192.168.3.77:8001/api/';
  // axios.defaults.baseURL = 'https://traceableplatform.azurewebsites.net/api/';
  axios.defaults.baseURL = 'https://traceableplatform.chinacloudsites.cn/webapi/';
  //axios.defaults.baseURL = 'https://qrc.wagobbu.cn/webapi/';
} else {
  axios.defaults.baseURL = 'http://localhost:41533/';
}

// http request interceptor
axios.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers.Authorization = `bearer ${store.getters.token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
)

// http response interceptor
axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    if (err.response) {
      switch (err.response.status) {
        case 401:
          store.commit(types.LOGOUT);
          router.replace({
            name: 'Error401'
          });

      }
    }
    return Promise.reject(err);
  }
)

export default axios;



// WEBPACK FOOTER //
// ./src/util/http.js